import React, { useContext } from 'react';
import { Fallback } from 'pages/fallback/fallback';
import { RouteContext } from 'entries/common/widgets/saved-project-configuration/context';
import { Calculation } from './forms/calculation';
import { Dimensions } from './forms/dimensions';
import { routes } from './consts/routes';

export const FormRouter = () => {
  const { route } = useContext(RouteContext);

  switch (route) {
    case routes.calculation:
      return <Calculation />;
    case routes.dimensions:
      return <Dimensions />;
    case routes.error:
      return (
        <Fallback
          title="Ой, что-то пошло не так..."
          description="Обновите страницу или попробуйте позже"
          buttonText="Обновить страницу"
        />
      );
    default:
      return <Calculation />;
  }
};
